import { checkEmptyTextAndZeroWidth, elementsListToHtml, getTextComponentColorSpan, getTextParagraphs, isColorPaletteKey } from './utils';
export const updateTextComponentTextColor = (html, color) => {
  const textParagraphs = getTextParagraphs(html);
  const updatedTextParagraphs = Array.from(textParagraphs).map(paragraph => {
    const element = paragraph;
    const text = checkEmptyTextAndZeroWidth(paragraph);
    if (!text) {
      return paragraph;
    }
    const textSpan = getTextComponentColorSpan(element);
    if (!textSpan) {
      const newTextSpan = document.createElement('span');
      const paragraphContent = element.innerHTML;
      newTextSpan.style.color = color;
      element.innerHTML = '';
      newTextSpan.innerHTML = paragraphContent;
      element.append(newTextSpan);
      return paragraph;
    }
    const textSpanClass = Array.from(textSpan.classList).find(isColorPaletteKey);
    if (textSpanClass) {
      textSpan.classList.remove(textSpanClass);
    }
    textSpan.style.color = color;
    return paragraph;
  });
  return elementsListToHtml(updatedTextParagraphs);
};
//# sourceMappingURL=update-text-component-text-color.js.map